import { render, staticRenderFns } from "./addPatient.vue?vue&type=template&id=84eb178c&scoped=true&"
import script from "./addPatient.vue?vue&type=script&lang=js&"
export * from "./addPatient.vue?vue&type=script&lang=js&"
import style0 from "./addPatient.vue?vue&type=style&index=0&id=84eb178c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84eb178c",
  null
  
)

export default component.exports